import { C } from "./const";

const IntroCtaBanner = () => {
    return (
        <section
            style={{
                background: `linear-gradient(135deg, ${C.primaryDark} 0%, ${C.primary} 100%)`,
                padding: "70px 24px",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
            }}
        >
            <div
                style={{
                    position: "absolute",
                    width: 320,
                    height: 320,
                    borderRadius: "50%",
                    background: C.accent,
                    opacity: 0.06,
                    top: -100,
                    left: "10%",
                    pointerEvents: "none",
                }}
            />
            <div style={{ position: "relative", zIndex: 1, maxWidth: 640, margin: "0 auto" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>🛡️</div>
                <h2
                    style={{
                        color: C.white,
                        fontSize: "clamp(22px,4vw,34px)",
                        fontWeight: 900,
                        marginBottom: 14,
                        lineHeight: 1.45,
                    }}
                >
                    همین امروز بیمه‌نامه خود را دریافت کنید
                </h2>
                <p style={{ color: "rgba(255,255,255,.8)", fontSize: 16, lineHeight: 1.8, marginBottom: 32 }}>
                    مشاوره رایگان، صدور فوری و پشتیبانی ۲۴ ساعته — همه چیز در یک جا
                </p>
                <a
                    href="#contact"
                    className="hov-btn"
                    style={{
                        display: "inline-block",
                        background: C.accent,
                        color: C.primaryDark,
                        padding: "15px 40px",
                        borderRadius: 12,
                        fontWeight: 800,
                        fontSize: 17,
                    }}
                >
                    دریافت مشاوره رایگان ←
                </a>
            </div>
        </section>

    );
}
export default IntroCtaBanner;